webpackJsonp([110896221861173],{

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  height: 90%;\n  width: 100%;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n'], ['\n  position: absolute;\n  height: 90%;\n  width: 100%;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: ', 'px;\n  height: ', 'px;\n  position: relative;\n  border-radius: 50%;\n  margin: 0 auto;\n\n  > svg, > div {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n'], ['\n  width: ', 'px;\n  height: ', 'px;\n  position: relative;\n  border-radius: 50%;\n  margin: 0 auto;\n\n  > svg, > div {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  0% {\n    transform: scale(1) translateY(0);\n    opacity: 1;\n  }\n  90% {\n    transform: translateY(104px) scale(0.02);\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(104px) scale(0.02);\n  }\n'], ['\n  0% {\n    transform: scale(1) translateY(0);\n    opacity: 1;\n  }\n  90% {\n    transform: translateY(104px) scale(0.02);\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(104px) scale(0.02);\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n'], ['\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: ', ';\n'], ['\n  display: ', ';\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  width: ', 'px;\n  height: ', 'px;\n  border-radius: 50%;\n  background: url(', ') 0 0 no-repeat;;\n  background-size: 100% 100%;\n  animation: ', ';\n'], ['\n  width: ', 'px;\n  height: ', 'px;\n  border-radius: 50%;\n  background: url(', ') 0 0 no-repeat;;\n  background-size: 100% 100%;\n  animation: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _config = __webpack_require__(17);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _Logo = __webpack_require__(37);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// Components
	
	
	var PageWrapper = _styledComponents2.default.section(_templateObject);
	
	var CircleWrapper = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props.size;
	}, function (props) {
	  return props.size;
	});
	
	var revealLogo = (0, _styledComponents.keyframes)(_templateObject3);
	
	var SkinSVG = _styledComponents2.default.svg(_templateObject4);
	
	var Heading = _styledComponents2.default.h1(_templateObject5, function (props) {
	  return props.hide ? 'none' : 'block';
	});
	
	var TagLine = _styledComponents2.default.p(_templateObject5, function (props) {
	  return props.hide ? 'none' : 'block';
	});
	
	var Andy = _styledComponents2.default.div(_templateObject6, function (props) {
	  return props.size;
	}, function (props) {
	  return props.size;
	}, (0, _gatsbyLink.withPrefix)('/images/andy.jpg'), function (props) {
	  return props.hide ? revealLogo + ' 0.6s linear forwards' : 'none';
	});
	
	var IntroPage = function (_React$Component) {
	  _inherits(IntroPage, _React$Component);
	
	  function IntroPage(props) {
	    _classCallCheck(this, IntroPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      logoRevealed: false
	    };
	    _this._handleTapped = _this._handleTapped.bind(_this);
	    return _this;
	  }
	
	  IntroPage.prototype._handleTapped = function _handleTapped() {
	    var _this2 = this;
	
	    this.setState({
	      logoRevealed: !this.state.logoRevealed
	    }, function () {
	      var yTo = _this2.state.logoRevealed ? 100 : 0;
	      var duration = _this2.state.logoRevealed ? 2 : 0.5;
	      var rotation = _this2.state.logoRevealed ? 90 : 0;
	
	      // TweenMax.set(this._clip1, {
	      //   rotation: 0,
	      //   transformOrigin: '320px center'
	      // });
	
	      TweenMax.to(_this2._clip1, duration, {
	        rotation: -rotation,
	        transformOrigin: '320px center',
	        // y: yTo,
	        ease: Power2.easeInOut,
	        repeat: false
	      });
	
	      TweenMax.to(_this2._clip2, duration, {
	        rotation: -rotation,
	        transformOrigin: '320px center',
	        ease: Power2.easeInOut,
	        repeat: false,
	        delay: duration * 0.4
	      });
	
	      // middle slice
	      TweenMax.to(_this2._clip5, duration, {
	        y: yTo,
	        ease: Power2.easeInOut,
	        repeat: false,
	        delay: duration * 0.8
	      });
	
	      TweenMax.to(_this2._clip3, duration, {
	        rotation: rotation,
	        transformOrigin: '-180px center',
	        ease: Power2.easeInOut,
	        repeat: false,
	        delay: duration * 1.2
	      });
	
	      TweenMax.to(_this2._clip4, duration, {
	        rotation: rotation,
	        transformOrigin: '-180px center',
	        ease: Power2.easeInOut,
	        repeat: false,
	        delay: duration * 1.6
	      });
	    });
	  };
	
	  IntroPage.prototype.render = function render() {
	    var _this3 = this;
	
	    var logoRevealed = this.state.logoRevealed;
	
	    return _react2.default.createElement(
	      PageWrapper,
	      null,
	      _react2.default.createElement(
	        CircleWrapper,
	        { onClick: this._handleTapped, size: 320 },
	        _react2.default.createElement(_Logo2.default, { size: 320 }),
	        _react2.default.createElement(
	          SkinSVG,
	          { viewBox: '0 0 100 100', width: 320, height: 320 },
	          _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('circle', { cx: 50, cy: 50, r: 50, fill: 'url(#andy)', clipPath: 'url(#clip-1)' }),
	            _react2.default.createElement('circle', { cx: 50, cy: 50, r: 50, fill: 'url(#andy)', clipPath: 'url(#clip-2)' }),
	            _react2.default.createElement('circle', { cx: 50, cy: 50, r: 50, fill: 'url(#andy)', clipPath: 'url(#clip-3)' }),
	            _react2.default.createElement('circle', { cx: 50, cy: 50, r: 50, fill: 'url(#andy)', clipPath: 'url(#clip-4)' }),
	            _react2.default.createElement('circle', { cx: 50, cy: 50, r: 50, fill: 'url(#andy)', clipPath: 'url(#clip-5)' })
	          ),
	          _react2.default.createElement(
	            'g',
	            { opacity: 0 },
	            _react2.default.createElement('path', { d: 'M 0 0 h 25 c -10 10, -10 90, 0 100 h -25 z', fill: 'red' }),
	            _react2.default.createElement('path', { d: 'M 25 0 h 25 c -10 10, -10 90, 0 100 h -25 c -10 -10, -10 -90, 0 -100 z', fill: 'blue' }),
	            _react2.default.createElement('path', { d: 'M 50 0 h 25 c 10 10, 10 90, 0 100 h -25 c 10 -10, 10 -90, 0 -100 z', fill: 'green' }),
	            _react2.default.createElement('path', { d: 'M 75 0 h 25 v 100 h -25 c 10 -10, 10 -90, 0 -100 z', fill: 'red' }),
	            _react2.default.createElement('path', { d: 'M 50 0 c -12 5, -12 95, 0 100 c 12 -5, 12 -95, 0 -100 z', fill: 'yellow' })
	          ),
	          _react2.default.createElement(
	            'defs',
	            null,
	            _react2.default.createElement(
	              'pattern',
	              { id: 'andy', patternUnits: 'userSpaceOnUse', width: '100%', height: '100' },
	              _react2.default.createElement('image', { className: 'andy', xlinkHref: (0, _gatsbyLink.withPrefix)('/images/andy.jpg'), x: '0', y: '0',
	                width: '100', height: '100' })
	            ),
	            _react2.default.createElement(
	              'clipPath',
	              { id: 'clip-1' },
	              _react2.default.createElement('path', { d: 'M 0 0 h 26 c -10 10, -10 90, 0 100 h -26 z', ref: function ref(_c) {
	                  _this3._clip1 = _c;
	                } })
	            ),
	            _react2.default.createElement(
	              'clipPath',
	              { id: 'clip-2' },
	              _react2.default.createElement('path', { d: 'M 25 0 h 26 c -10 10, -10 90, 0 100 h -26 c -10 -10, -10 -90, 0 -100 z', ref: function ref(_c) {
	                  _this3._clip2 = _c;
	                } })
	            ),
	            _react2.default.createElement(
	              'clipPath',
	              { id: 'clip-3' },
	              _react2.default.createElement('path', { d: 'M 50 0 h 26 c 10 10, 10 90, 0 100 h -26 c 10 -10, 10 -90, 0 -100 z', ref: function ref(_c) {
	                  _this3._clip3 = _c;
	                } })
	            ),
	            _react2.default.createElement(
	              'clipPath',
	              { id: 'clip-4' },
	              _react2.default.createElement('path', { d: 'M 75 0 h 26 v 100 h -26 c 10 -10, 10 -90, 0 -100 z', ref: function ref(_c) {
	                  _this3._clip4 = _c;
	                } })
	            ),
	            _react2.default.createElement(
	              'clipPath',
	              { id: 'clip-5' },
	              _react2.default.createElement('path', { d: 'M 50 0 c -12 5, -12 95, 0 100 c 12 -5, 12 -95, 0 -100 z', ref: function ref(_c) {
	                  _this3._clip5 = _c;
	                } })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        Heading,
	        { hide: logoRevealed },
	        '@andyshora'
	      ),
	      _react2.default.createElement(
	        TagLine,
	        { hide: logoRevealed },
	        'JAMstack London'
	      ),
	      _react2.default.createElement(
	        Heading,
	        { hide: !logoRevealed },
	        'too many kiwis'
	      ),
	      _react2.default.createElement(
	        TagLine,
	        { hide: !logoRevealed },
	        _config2.default.TAG_LINE
	      )
	    );
	  };
	
	  return IntroPage;
	}(_react2.default.Component);
	
	;
	
	exports.default = IntroPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-jamstack-js-b8b01fe4872645c4d154.js